export const TOAST_MESSAGE_ADDED = '[Toast] message added';
export const TOAST_MESSAGE_REMOVED = '[Toast] message closed';
export const TOAST_MESSAGES_REMOVED = '[Toast] messages closed';

const message = (dispatch, severity, body, persist = false, display_length = 5000) => {
    const id = Math.floor(Math.random() * 100000000);
    if (!persist) {
        setTimeout(() => dispatch(CloseMessageAction(id)), display_length);
    }

    return {
        type: TOAST_MESSAGE_ADDED,
        severity,
        body: body.toString(),
        persist,
        display_length,
        id
    }
};
export const SuccessMessageAction = (body, persist = false, display_length = 5000) => dispatch => dispatch(message(dispatch, 'success', body, persist, display_length));
export const ErrorMessageAction = (body, persist = false, display_length = 5000) => dispatch => dispatch(message(dispatch, 'error', body, persist, display_length));
export const WarningMessageAction = (body, persist = false, display_length = 5000) => dispatch => dispatch(message(dispatch, 'warning', body, persist, display_length));
export const InfoMessageAction = (body, persist = false, display_length = 5000) => dispatch => dispatch(message(dispatch, 'info', body, persist, display_length));
export const CloseMessageAction = id => {
    return {
        type: TOAST_MESSAGE_REMOVED,
        id
    }
};
export const CloseMessagesAction = () => {
    return {
        type: TOAST_MESSAGES_REMOVED
    }
};
